//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconMiscWallet(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M5 6C4.59 6 4 5.68 4 5V4H20V2H2V19C2 20.65 3.35 22 5 22H22V6H5ZM20 20H5C4.45 20 4 19.55 4 19V7.83C4.32 7.94 4.66 8 5 8H20V20Z" fill="currentColor" /><path d="M16 16.25C17.2426 16.25 18.25 15.2426 18.25 14C18.25 12.7574 17.2426 11.75 16 11.75C14.7574 11.75 13.75 12.7574 13.75 14C13.75 15.2426 14.7574 16.25 16 16.25Z" fill="currentColor" /></svg>;
}
export default IconMiscWallet;